import { Component, ViewChild, HostListener } from '@angular/core';
import { NgxMasonryOptions } from './ngx-masonry/ngx-masonry-options';
import { NgxMasonryComponent } from './ngx-masonry/ngx-masonry.component';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'app';

  scrollToEl($el: HTMLElement): void {
    const elId: string = $el.id;
    $el.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
    window.location.hash = elId;
    this.activeNav = elId;
  }

  public masonryOptions: NgxMasonryOptions = {
    gutter: 34,
  };

  @ViewChild(NgxMasonryComponent) masonry: NgxMasonryComponent;

  masonryImages: string[];
  brands: any;
  // allBrands: any;
  // brands3: any;
  limitBrandCarousel = 6;
  limit = 6;//15;

  public getScreenWidth: any;
  public getScreenHeight: any;

  activeNav: string = 'beranda';

  contentBrands = [
    {
      desc: 'SOMETHINC terinspirasi oleh teman-teman milenial yang mencari produk Perawatan Kulit & Rias Wajah Bersertifikat Halal untuk gaya hidup aktif mereka',
      name: 'Somethinc',
      tagline: 'Be you, Be Somethinc',
      logoImg: 'assets/img/principles/somethinc.png'
    },
    {
      desc: 'Rangkaian produk PIGEON Teens dibuat melalui riset dan uji klinis sebelum produk tersebut diluncurkan sesuai dengan philosophy 3S PIGEON. Selain itu kami juga sangat memperhatikan kualitas dan keamanan dari setiap produk yang kami pasarkan.',
      name: 'Pigeon Teens',
      tagline: 'Your BeYouthyful Journey',
      logoImg: 'assets/img/principles/pigeon-teens.png',
    },
    // {
    //   desc: 'BONAVIE Body Lotion is made with Europe’s luxury perfume. It is produced and formulated in French Laboratory with international standards that has experience for more than 250 years.',
    //   name: 'Bonavie',
    //   tagline: 'Confidence in you',
    //   logoImg: 'assets/img/principles/bonavie.png',
    // },
    {
      desc: 'Animate Official adalah Brand Skincare dan Kosmetik lokal yang sudah tervirifikasi BPOM dan HALAL CANTIK GA HARUS MAHAL',
      name: 'Animate',
      tagline: 'Menghidupkan',
      logoImg: 'assets/img/principles/animate.png',
    },
    {
      desc: 'Salsa Cosmetics menciptakan berbagai produk kosmetik dan produk perawatan kulit dan tubuh yang berasal dari bahan alami untuk kecantikan yang maksimal dan natural.',
      name: 'Salsa',
      tagline: 'Beauty made easy',
      logoImg: 'assets/img/principles/salsa.png',
    },
    {
      desc: 'Menciptakan pangan yang sedekat mungkin dengan aslinya (pure food)',
      name: 'Nayz',
      tagline: 'Sekali Organik, Tetap Organik',
      logoImg: 'assets/img/principles/nayz.png',
    },
    {
      desc: 'Menyediakan produk kosmetik berkualitas dengan harga ekonomis',
      name: 'Madam Gie',
      tagline: 'Memukau Sepanjang Hari',
      logoImg: 'assets/img/principles/madame-gie.png',
    },
    {
      desc: 'Establish Himalaya as a science-based, problem-solving, head-to-heel brand, harnessed from nature\'s wealth and characterized by trust and healthy live',
      name: 'Himalaya',
      tagline: 'Bring wellness and joy to every home via herbal solutions based on science',
      logoImg: 'assets/img/principles/himalaya.png',
    },
    {
      desc: 'Pewarna rambut professional yang akan membuat rambut anda lebih fashionable',
      name: 'Marimar',
      tagline: 'Beauty For Everyone',
      logoImg: 'assets/img/principles/marimar.png',
    },
    {
      desc: 'Perusahaan kosmetika yang aman dan inovatif dalam formulasi dan tampilan produk, dengan harga yang terjangkau',
      name: 'Rantaeus',
      tagline: 'Bersama Kita Bisa',
      logoImg: 'assets/img/principles/rantaeus.png',
    },
    // {
    //   desc: 'Kami percaya dengan keindahan dan kecantikan yang berasal dari dalam serta perawatan kulit sehat cantik bercahaya. LYSCA beauty dikembangkan oleh PT. Mitra Hokindo Sukses (MHS Lab) di Sidoarjo, pada tahun 2019.',
    //   name: 'Lysca',
    //   tagline: 'Your Skin Nutrition',
    //   logoImg: 'assets/img/principles/lysca.png',
    // },
    // {
    //   desc: 'Lebih dari riasan wajah, kami menciptakan kecantikan yang menyenangkan. Warna dan bahan merupakan inspirasi utama kami. Kamu hanya perlu menikmati kecantikan yang menyenangkan dari berbagai rangkaian produk barenbliss',
    //   name: 'Barenbliss',
    //   tagline: 'Beauty in-joy',
    //   logoImg: 'assets/img/principles/barenbliss.png'
    // },
    // {
    //   desc: 'Bioaqua specialized in high-performance, plant-based skincare, and makeup. Bioaqua\'s expertise is well-known in acne and blackheads treatments, exfoliators, masks, hydration, and more.',
    //   name: 'Bioaqua',
    //   tagline: 'Safe to Skin',
    //   logoImg: 'assets/img/principles/bioaqua.png'
    // },
    // {
    //   desc: 'DAZZLE ME is a new generation cosmetics brand founded by a group of young beauty zealots and experts from across the world. After countless nights spent on refining the formula and design, the first generation of DAZZLE ME products were born.',
    //   name: 'Dazzle Me',
    //   tagline: 'Your handy & funky makeup buddy',
    //   logoImg: 'assets/img/principles/dazzle-me.png'
    // },
    // {
    //   desc: 'The synergy of science-backed nutritious ingredients for skin & cosmetical function, your inside-out natural beauty',
    //   name: 'Everwhite',
    //   tagline: 'The best thing starts from you',
    //   logoImg: 'assets/img/principles/everwhite.png'
    // },
    // {
    //   desc: 'Kaila adalah brand kecantikan lokal yang hadir sejak 2017 di bawah naungan PT Multi Indocitra Tbk. Kaila memiliki arti nama mahkota dan kebahagiaan, sehingga kami berharap setiap produk Kaila mampu meningkatkan rasa percaya diri setiap orang dan memberikan semangat dalam menjalani hari-hari.',
    //   name: 'Kaila',
    //   tagline: 'Express Your Natural Beauty',
    //   logoImg: 'assets/img/principles/kaila.png'
    // },
    // {
    //   desc: 'Beauty, cosmetic & personal care.',
    //   name: 'Lomira',
    //   tagline: 'Makeup Murah Under 50k',
    //   logoImg: 'assets/img/principles/lomira.png'
    // },
    // {
    //   desc: 'PT Aroma prima livindo is a fast growing consumer product mainly focusing in Perfumery and beauty product. We strive for excellence in making the best local product from Indonesia.',
    //   name: 'Morris',
    //   tagline: 'Ingat Parfum Ya Morris',
    //   logoImg: 'assets/img/principles/morris.png'
    // },
    // {
    //   desc: 'O.TWO.O Brand Kecantikan yang Menyediakan Produk Riasan Wajah Berkualitas, Memiliki Kemasan yang Elegan dan Banyak Varian.',
    //   name: 'O.TWO.O',
    //   tagline: 'Make Beauty Become Daily',
    //   logoImg: 'assets/img/principles/otwoo.png'
    // },
    // {
    //   desc: 'Wetkins Antiseptic Wet Wipes terbukti secara klinis mampu menyamai efektivitas hand sanitizer dalam membunuh 99.99% kuman. Wetkins Antiseptic Wet Wipes adalah solusi praktis untuk menjaga kebersihan kulit saat jauh dari air dan sabun.',
    //   name: 'Wetkins',
    //   tagline: 'Daily wipes and personal care',
    //   logoImg: 'assets/img/principles/wetkins.png'
    // },
    // {
    //   desc: 'Whitelab is here to solve all their skin problems. Whitelab products are created with premium ingredients and formulated by experts to produce the best products with maximum results. Whitelab products are safe to use everyday and already BPOM registered.',
    //   name: 'Whitelab',
    //   tagline: 'Not Your Ordinary Skincare',
    //   logoImg: 'assets/img/principles/whitelab.png'
    // },
    // {
    //   desc: 'Y.O.U Beauty is committed to providing all women accessible beauty with innovative technology and fashionable design, inspiring them to keep exquisite attitude and blooming the everlasting beauty.',
    //   name: 'YOU',
    //   tagline: 'Long-Lasting Beauty',
    //   logoImg: 'assets/img/principles/you.png'
    // },
  ];

  // contentBrands2 = [
  //   {
  //     desc: 'Rangkaian produk PIGEON Teens dibuat melalui riset dan uji klinis sebelum produk tersebut diluncurkan sesuai dengan philosophy 3S PIGEON. Selain itu kami juga sangat memperhatikan kualitas dan keamanan dari setiap produk yang kami pasarkan.',
  //     name: 'Pigeon Teens',
  //     tagline: 'Find your perfect Shade',
  //     logoImg: 'assets/img/principles/pigeon-teens.png',
  //   },
  //   {
  //     desc: 'Salsa Cosmetics menciptakan berbagai produk kosmetik dan produk perawatan kulit dan tubuh yang berasal dari bahan alami untuk kecantikan yang maksimal dan natural.',
  //     name: 'Salsa',
  //     tagline: 'Find your perfect Shade',
  //     logoImg: 'assets/img/principles/salsa.png',
  //   },
  //   {
  //     desc: 'Kami percaya dengan keindahan dan kecantikan yang berasal dari dalam serta perawatan kulit sehat cantik bercahaya. LYSCA beauty dikembangkan oleh PT. Mitra Hokindo Sukses (MHS Lab) di Sidoarjo, pada tahun 2019.',
  //     name: 'Lysca',
  //     tagline: 'Find your perfect Shade',
  //     logoImg: 'assets/img/principles/lysca.png',
  //   },
  //   {
  //     desc: 'SOMETHINC terinspirasi oleh teman-teman milenial yang mencari produk Perawatan Kulit & Rias Wajah Bersertifikat Halal untuk gaya hidup aktif mereka',
  //     name: 'Somethinc',
  //     tagline: 'Find your perfect Shade',
  //     logoImg: 'assets/img/principles/somethinc.png'
  //   },
  //   {
  //     desc: 'BONAVIE Body Lotion is made with Europe’s luxury perfume. It is produced and formulated in French Laboratory with international standards that has experience for more than 250 years.',
  //     name: 'Bonavie',
  //     tagline: 'Find your perfect Shade',
  //     logoImg: 'assets/img/principles/bonavie.png',
  //   },
  //   {
  //     desc: 'Animate Official adalah Brand Skincare dan Kosmetik lokal yang sudah tervirifikasi BPOM dan HALAL CANTIK GA HARUS MAHAL',
  //     name: 'Animate',
  //     tagline: 'Find your perfect Shade',
  //     logoImg: 'assets/img/principles/animate.png',
  //   },
  // ];

  // contentBrands3 = [
  //   {
  //     desc: 'Salsa Cosmetics menciptakan berbagai produk kosmetik dan produk perawatan kulit dan tubuh yang berasal dari bahan alami untuk kecantikan yang maksimal dan natural.',
  //     name: 'Salsa',
  //     tagline: 'Find your perfect Shade',
  //     logoImg: 'assets/img/principles/salsa.png',
  //   },
  //   {
  //     desc: 'Rangkaian produk PIGEON Teens dibuat melalui riset dan uji klinis sebelum produk tersebut diluncurkan sesuai dengan philosophy 3S PIGEON. Selain itu kami juga sangat memperhatikan kualitas dan keamanan dari setiap produk yang kami pasarkan.',
  //     name: 'Pigeon Teens',
  //     tagline: 'Find your perfect Shade',
  //     logoImg: 'assets/img/principles/pigeon-teens.png',
  //   },
  //   {
  //     desc: 'Kami percaya dengan keindahan dan kecantikan yang berasal dari dalam serta perawatan kulit sehat cantik bercahaya. LYSCA beauty dikembangkan oleh PT. Mitra Hokindo Sukses (MHS Lab) di Sidoarjo, pada tahun 2019.',
  //     name: 'Lysca',
  //     tagline: 'Find your perfect Shade',
  //     logoImg: 'assets/img/principles/lysca.png',
  //   },
  //   {
  //     desc: 'SOMETHINC terinspirasi oleh teman-teman milenial yang mencari produk Perawatan Kulit & Rias Wajah Bersertifikat Halal untuk gaya hidup aktif mereka',
  //     name: 'Somethinc',
  //     tagline: 'Find your perfect Shade',
  //     logoImg: 'assets/img/principles/somethinc.png'
  //   },
  //   {
  //     desc: 'BONAVIE Body Lotion is made with Europe’s luxury perfume. It is produced and formulated in French Laboratory with international standards that has experience for more than 250 years.',
  //     name: 'Bonavie',
  //     tagline: 'Find your perfect Shade',
  //     logoImg: 'assets/img/principles/bonavie.png',
  //   },
  //   {
  //     desc: 'Animate Official adalah Brand Skincare dan Kosmetik lokal yang sudah tervirifikasi BPOM dan HALAL CANTIK GA HARUS MAHAL',
  //     name: 'Animate',
  //     tagline: 'Find your perfect Shade',
  //     logoImg: 'assets/img/principles/animate.png',
  //   }
  // ];

  sliceIntoChunks(arr: any, chunkSize: any) {
    const res = [];
    for (let i = 0; i < arr.length; i += chunkSize) {
      const chunk = arr.slice(i, i + chunkSize);
      res.push(chunk);
    }
    return res;
  }

  ngOnInit() {
    this.getScreenWidth = window.innerWidth;
    this.getScreenHeight = window.innerHeight;
    //if screen sm
    if (this.getScreenWidth <= 576) {
      this.limitBrandCarousel = 2;
    }

    // this.brands = this.contentBrands.slice(0, this.limitBrandCarousel);
    this.brands = this.sliceIntoChunks(this.contentBrands, this.limitBrandCarousel);

    // this.allBrands = this.sliceIntoChunks(this.contentBrands, this.limitBrandCarousel);
    // this.brands2 = this.contentBrands2.slice(0, this.limit);
    // this.brands3 = this.contentBrands3.slice(0, this.limit);
    //harusnya direload setelah image semuanya reloaded
    //selanjutnya tes jika imagenya dari local, bukan load dari internet, kalau load dari inet berarti harus nunggu loaded semua dulu
    // this.masonry.reloadItems();
    // this.masonry.layout();

    //nav
    if (window.location.hash == '') {
      this.activeNav = 'beranda';
    } else {
      this.activeNav = window.location.hash.replace('#', '');
      console.log(this.activeNav);
    }
  }

  @HostListener('window:resize', ['$event'])
  onWindowResize() {
    this.getScreenWidth = window.innerWidth;
    this.getScreenHeight = window.innerHeight;
    if (this.getScreenWidth <= 576) {
      this.limitBrandCarousel = 2;
    } else {
      this.limitBrandCarousel = 6;
    }
    this.brands = this.sliceIntoChunks(this.contentBrands, this.limitBrandCarousel);
  }

  navToggle(event) {
    /*Toggle dropdown list*/
    /*https://gist.github.com/slavapas/593e8e50cf4cc16ac972afcbad4f70c8*/

    var navMenuDiv = document.getElementById("nav-content");
    var navMenu = document.getElementById("nav-toggle");

    document.onclick = check;
    function check(e) {
      var target = (e && e.target) || (event && event.srcElement);

      //Nav Menu
      if (!checkParent(target, navMenuDiv)) {
        // click NOT on the menu
        if (checkParent(target, navMenu)) {

          // click on the link
          if (navMenuDiv.classList.contains("hidden")) {
            navMenuDiv.classList.remove("hidden");
          } else {
            navMenuDiv.classList.add("hidden");
          }
        } else {
          // click both outside link and outside menu, hide menu
          navMenuDiv.classList.add("hidden");
        }
      }
    }
    function checkParent(t, elm) {
      while (t.parentNode) {
        if (t == elm) {
          return true;
        }
        t = t.parentNode;
      }
      return false;
    }
  }

  // showMoreImages() {
  //   this.limit += 15;
  //   this.masonryImages = this.dummyPictures.slice(0, this.limit);
  // }

  // insertImage() {
  //   this.masonryImages.splice(0, 0, this.dummyPictures[0]);
  //   this.masonry.reloadItems();
  //   this.masonry.layout();
  // }

  // removeImage() {
  //   this.masonryImages.pop();
  // }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts